module.exports = __webpack_public_path__ + "img/garrafas.252ddd9a.png";